import { useState, useEffect } from "react";
import "./account-management.css";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Grid } from "@mui/material";
import { getAllUsers } from "src/apis/user_apis";
import { getServerInfo } from "src/util/auth";
import DataGridContainer from "src/components/DataGrid/DataGridContainer";
import CreateUserForm from "src/components/Forms/CreateUserForm";

const roles = [
  {
    id: 1,
    name: "Admin",
    label: "Admin",
    value: "Admin",
  },
  {
    id: 2,
    name: "Facility Manager",
    label: "Facility Manager",
    value: "Facility Manager",
  },

  {
    id: 3,
    name: "Maintenance Operator",
    label: "Maintenance Officer",
    value: "Maintenance Officer",
  },
  {
    id: 4,
    name: "Business Manager",
    label: "Business Purpose User",
    value: "Business Purpose User",
  },
  {
    id: 5,
    name: "Operator",
    label: "Operator",
    value: "Operator",
  },
];

const Table = () => {
  const [outcome, setOutcome] = useState(false); // popup control var
  const [success, setSuccess] = useState(false);
  const [advice, setadvice] = useState("");

  const [open, setOpen] = useState(false);

  const [apidata, setApidata] = useState("");

  const [searchTerm, setSearchTerm] = useState(""); // state for search term

  const [isCreateUserForm, setIsCreateUserForm] = useState(false);

  const [data, setData] = useState([
    {
      ap_id: "",
      id: 1,
      FirstName: "",
      LastName: "",
      PhoneNumber: "-",
      Email: "",
      Role: [],
      roleId: "",
    },
    {
      ap_id: "",
      id: 2,
      FirstName: "",
      LastName: "",
      PhoneNumber: "-",
      Email: "",
      Role: [],
      roleId: "",
    },
  ]); // sample data

  const filteredData = data.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const mapTableRows = (data) => {
    return data.map((item) => ({
      id: item.id,
      firstName: item.FirstName,
      lastName: item.LastName,
      phoneNumber: item.PhoneNumber,
      email: item.Email,
      role: item.Role,
    }));
  };

  const [tableRows, setTableRows] = useState([]);

  useEffect(() => {
    setTableRows(mapTableRows(filteredData));
  }, [filteredData]);

  /****LOAD ALL USERS */
  useEffect(() => {
    const info = getServerInfo();
    const url = info[0];
    const token = info[1];

    getAllUsers(url, token)
      .then((response) => {
        setApidata(response.data.response);
        setData(
          response.data.response.map((user) => ({
            ap_id: user.id,
            id: user.userName,
            FirstName: user.firstName,
            LastName: user.lastName,
            Role: user.roles.map((role) => role.description),
            PhoneNumber: user.cellNumber,
            Email: user.email,
            roleId: user.roles[0].id,
          }))
        );
        //  console.log("it works : ", apidata);
        console.log("data loaded from api", response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [outcome, success]);

  const handlepopup = () => {
    setOutcome(false);
    setSuccess(false);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleClickOpen = () => {
    setIsCreateUserForm(true);
    setOpen(true);
  };

  return (
    <div className="accountManagement">
      <h1>Account Management</h1>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={6} sm={6}>
          <div className="search-container">
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={6} sm={6}>
          <div className="mainButton">
            <ButtonPolicy
              policy="ticket.edit"
              onClick={handleClickOpen}
              variant="contained"
              sx={{
                marginTop: 2,
                width: 250,
                borderRadius: "0",
              }}
            >
              Add new user
            </ButtonPolicy>
          </div>
        </Grid>
      </Grid>
      <Dialog open={outcome} onClose={handlepopup}>
        <div className="modalContainer" style={{ backgroundColor: "#282b30" }}>
          <DialogContent>
            <div className="advice">{advice}</div>
          </DialogContent>
        </div>
      </Dialog>
      <DataGridContainer
        type={"Account Management"}
        tableRows={tableRows}
        roles={roles}
        data={data}
        setData={setData}
        setSuccess={setSuccess}
        setOutcome={setOutcome}
        setadvice={setadvice}
        filteredData={filteredData}
        dataGridPageSize={10}
      />
      {isCreateUserForm && (
        <CreateUserForm
          roles={roles}
          open={open}
          setOpen={setOpen}
          setOutcome={setOutcome}
          setadvice={setadvice}
          setIsCreateUserForm={setIsCreateUserForm}
        />
      )}
    </div>
  );
};

export default Table;
